import { render, staticRenderFns } from "./genManagement.vue?vue&type=template&id=798377d0&scoped=true&"
import script from "./genManagement.vue?vue&type=script&lang=js&"
export * from "./genManagement.vue?vue&type=script&lang=js&"
import style0 from "./genManagement.vue?vue&type=style&index=0&id=798377d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798377d0",
  null
  
)

export default component.exports